import { createFileRoute } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { seo, toDescription } from "@/lib/seo";
import BlogPost from "@/pages/BlogPost";

// The post is loaded here rather than in the component so that both the head
// tags and the article body are server-rendered. Previously the page fetched
// client-side, so crawlers saw the site-wide default title and an empty body.
export const Route = createFileRoute("/_site/blog/$slug")({
  loader: async ({ params }) => {
    const { data } = await supabase
      .from("blog_posts")
      .select("*")
      .eq("slug", params.slug)
      .eq("published", true)
      .or("scheduled_at.is.null,scheduled_at.lte.now()")
      .maybeSingle();
    return { post: data ?? null };
  },
  head: ({ loaderData, params }) => {
    const post = loaderData?.post;
    if (!post) return {};
    return seo({
      title: `${post.title} | Kodiak Structures & Exteriors Blog`,
      description: toDescription(post.excerpt || post.content || ""),
      path: `/blog/${params.slug}`,
      image: post.image_url,
      type: "article",
    });
  },
  component: BlogPost,
});
